import React from 'react';

import { Box, Typography } from '@mui/material';

import { translate } from '@/data/fixture-transalations';
import WrapperBarComponent from '@/components/shared/charts/BarComponent/wrapper-bar-component';

const PlayersGraphicPoints = ({ player }) => {
    // Obtener las jornadas y traducirlas si es necesario
    const weeks = player?.weeks || [];
    const sortedWeeks = weeks.sort((a, b) => b - a);
    const jornadas = sortedWeeks.map((item) => translate(`J${item}`));

    // Obtener los puntos por jornada
    const puntos = [];

    sortedWeeks.forEach((week) => {
        const weekData = player.estadisticas?.playerStats?.find((item) => item.w === week);
        const points = weekData?.tp || 0;
        puntos.push(points);
    });

    const azul = 'rgba(25, 118, 210, 0.7)';
    const verde = 'rgba(75, 192, 75, 0.7)';
    const verde_oscuro = 'rgba(0, 128, 0, 0.7)';
    const naranja = 'rgba(255, 165, 0, 0.7)';
    const rojo = 'rgba(255, 99, 132, 0.7)';

    // Función para determinar el color de cada barra según los puntos obtenidos
    const getBarColor = (puntos) => {
        if (puntos >= 8) return azul;
        if (puntos >= 5) return verde;
        if (puntos >= 3) return verde_oscuro;
        if (puntos >= 1) return naranja;
        return rojo;
    };

    // Colores de la leyenda
    const colors = [
        { key: '8+ ptos', value: azul },
        { key: '5-7 ptos', value: verde },
        { key: '3-4 ptos', value: verde_oscuro },
        { key: '1-2 ptos', value: naranja },
        { key: '0 ptos', value: rojo },
    ];

    // Asignar colores a cada barra según los puntos
    const backgroundColors = puntos.map(getBarColor);

    const chartData = {
        labels: jornadas,
        datasets: [
            {
                label: 'Puntos',
                data: puntos,
                backgroundColor: backgroundColors, // Aplica colores dinámicos
                borderColor: 'rgba(0, 0, 0, 0.3)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
                text: 'Puntuaciones por jornada',
            },
        },
    };

    return (
        <Box
            mb={2}
            style={{ padding: '10px', boxShadow: '0 2px 8px rgba(0,0,0,.1)' }}
            width={{
                xs: '100%',
            }}
        >
            <Typography
                sx={{ color: 'hsl(265, 4%, 42%)', marginBottom: '8px', fontSize: '16px' }}
                fontWeight={500}
                textAlign={'center'}
            >
                Puntuaciones por jornada
            </Typography>
            <WrapperBarComponent text={''} data={chartData} options={options} />

            <Box display="flex" justifyContent="center" mt={2} gap={1}>
                {colors.map((item, index) => (
                    <Box
                        key={index}
                        fontSize={12}
                        backgroundColor={item.value}
                        color="#fff"
                        py={0.5}
                        width={55}
                        textAlign="center"
                        borderRadius={1}
                    >
                        {item.key}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PlayersGraphicPoints;
